import { InjectionToken } from '@angular/core';

export const HASHAUTHTOKEN = new InjectionToken<string>('hashauthtoken');
